import type { ReactNode } from "react";
import { cn } from "./cn";

/**
 * Cabecalho de pagina: rotulo, titulo, descricao e acoes.
 *
 * Existe para o respiro ser igual em toda tela. Sem ele, cada pagina empilhava
 * rotulo, titulo e texto com margens diferentes (ou nenhuma), e a tela ficava
 * "grudada". O espacamento vem dos tokens `gap-texto` (entre as linhas) e
 * `gap-bloco` (entre o texto e as acoes).
 */
export function CabecalhoDePagina({
  rotulo,
  titulo,
  descricao,
  acoes,
  className,
}: {
  /** Linha pequena em caixa alta acima do titulo (ex.: o cliente selecionado). */
  readonly rotulo?: ReactNode;
  readonly titulo: ReactNode;
  readonly descricao?: ReactNode;
  /** Botoes da pagina, alinhados a direita no desktop. */
  readonly acoes?: ReactNode;
  readonly className?: string | undefined;
}) {
  return (
    <header
      className={cn(
        "flex flex-col gap-bloco md:flex-row md:items-end md:justify-between",
        className,
      )}
    >
      <div className="flex max-w-2xl flex-col gap-texto">
        {rotulo ? (
          <p className="text-xs font-semibold tracking-[0.12em] text-primary uppercase">{rotulo}</p>
        ) : null}
        <h1 className="text-4xl leading-tight font-normal tracking-[-0.025em] text-foreground">
          {titulo}
        </h1>
        {descricao ? (
          <p className="text-base leading-relaxed text-muted-foreground">{descricao}</p>
        ) : null}
      </div>
      {acoes ? <div className="flex shrink-0 flex-wrap gap-3">{acoes}</div> : null}
    </header>
  );
}
